module.exports = __webpack_public_path__ + "img/qrcode1.8ee2ba9a.png";